export default __webpack_public_path__ + "static/media/vacancy-painel.e9640668.svg";